import { render, staticRenderFns } from "./AgeWidget.vue?vue&type=template&id=9a2c9b98&scoped=true&"
import script from "./AgeWidget.vue?vue&type=script&lang=js&"
export * from "./AgeWidget.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9a2c9b98",
  null
  
)

export default component.exports